/**
 * NavigationBar.js
 *
 * Copyright (c) apploft. GmbH
 */

import {
  XmarkBold,
  SquareAndPencilBold,
  TrashBold,
  NavigationBar,
  stringMatching,
} from 'apploft-cloud-forms';

import {
  ready,
  presentingList,
  presentingForm,
  fetchingItems,
  submittingForm,
  fetchingItem,
  presentingEditingForm,
} from './EndPoint/ContentStateSymbol';

import {form, selectSection, deleteItem} from './EndPoint/ContentEventSymbol';

function populateForList({_section, _api, items}, dispatch, strings) {
  return NavigationBar({
    string: `${items.length} ${stringMatching(strings, 'Items')}`,
    items: [
      {
        title: stringMatching(strings, 'Add Item'),
        icon: SquareAndPencilBold,
        onClick: () => {
          dispatch({event: form});
        },
      },
    ],
  });
}

function populateForReady({section, api, _items}, dispatch, strings) {
  if (!section || !api) {
    return NavigationBar({
      string: '',
    });
  }

  return NavigationBar({
    string: '',
    items: [
      {
        title: stringMatching(strings, 'Close'),
        icon: XmarkBold,
        onClick: () => {
          dispatch({event: selectSection, payload: {section, api, dispatch}});
        },
      },
    ],
  });
}

function populateForCreateItem({section, api, _items}, dispatch, strings) {
  return NavigationBar({
    string: stringMatching(strings, section.name),
    items: [
      {
        title: stringMatching(strings, 'Close'),
        icon: XmarkBold,
        onClick: () => {
          dispatch({event: selectSection, payload: {section, api, dispatch}});
        },
      },
    ],
  });
}

function populateForEditItem({section, api, _items, item}, dispatch, strings) {
  return NavigationBar({
    string: stringMatching(strings, section.name),
    items: [
      {
        title: stringMatching(strings, 'Delete Item'),
        icon: TrashBold,
        onClick: () => {
          dispatch({event: deleteItem, payload: {item, dispatch}});
        },
      },
      {
        title: stringMatching(strings, 'Close'),
        icon: XmarkBold,
        onClick: () => {
          dispatch({event: selectSection, payload: {section, api, dispatch}});
        },
      },
    ],
  });
}

function Main({state, data, dispatch, strings}) {
  switch (state) {
    case presentingList:
      return populateForList(data, dispatch, strings);

    case presentingForm:
      return populateForCreateItem(data, dispatch, strings);

    case presentingEditingForm:
      return populateForEditItem(data, dispatch, strings);

    case ready:
      return populateForReady(data, dispatch, strings);

    case fetchingItems:
    case submittingForm:
    case fetchingItem:
      if (typeof data !== 'string') {
        const {
          section: {name},
        } = data;

        return NavigationBar({
          string: `${stringMatching(strings, 'requesting')} ${name}`,
        });
      }

      return NavigationBar({string: data});

    default:
      throw new Error(
        `no matching view for state: ${state ? state.toString() : 'none'}`,
      );
  }
}

export default Main;
